import script from "./PatientVisitAddServiceGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientVisitAddServiceGeneral.vue?vue&type=script&setup=true&lang=js"

import "./PatientVisitAddServiceGeneral.vue?vue&type=style&index=0&id=5d9ecdb8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d9ecdb8"]])

export default __exports__